<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">{{title}}</h1>
        </section>

        <section id="body">
            <form [formGroup]="addBannerForm" (ngSubmit)="saveChanges(addBannerForm.value)">
                <mat-card>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <mat-form-field appearance="outline">
                            <mat-label>Seleccionar ciudad</mat-label>
                            <mat-select formControlName="CdCity" required>
                                <mat-option *ngFor="let city of allCities" [value]="city.id">
                                    {{city.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="addBannerForm.controls['CdCity'].hasError('required')">
                                Este campo es obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex=50>
                            <mat-form-field appearance="outline">
                                <mat-label>Posición del banner</mat-label>
                                <mat-select formControlName="NmPosition" required>
                                    <mat-option *ngFor="let option of position" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addBannerForm.controls['NmPosition'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex=50>
                            <mat-form-field appearance="outline">
                                <mat-label>Seleccionar comercios</mat-label>
                                <mat-select formControlName="StoresIds" required multiple>
                                    <mat-option *ngFor="let store of allStores" [value]="store.id">
                                        {{store.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>Los comercios seleccionados aparecerán al hacer click en el banner</mat-hint>
                                <mat-error *ngIf="addBannerForm.controls['StoresIds'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Imagen</mat-label>
                                <ngx-mat-file-input formControlName="Image" accept=".png, .jpg, .jpeg">
                                </ngx-mat-file-input>
                                <mat-error *ngIf="addBannerForm.controls['Image'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="IsActive" required>
                                    <mat-option *ngFor="let option of status" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addBannerForm.controls['IsActive'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="isEdit" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                        <img class="image-preview" [src]="DsImageUrl" />
                    </div>
                </mat-card>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button type="submit" [disabled]="!addBannerForm.valid" class="save-changes">GUARDAR
                        CAMBIOS</button>
                    <button routerLink="/banners-management" mat-raised-button class="cancel-changes">CANCELAR</button>

                </div>
            </form>
        </section>

    </div>
</div>
